import { DeviceType } from 'api/generated';
import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';

export type IdentitySignInInput = {
  formData?: {
    Login: string;
    Password: string;
    DeviceType?: DeviceType;
    Device?: string;
    Location?: string;
  };
};

export const useIdentitySignInMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentitySignIn>>,
      unknown,
      {
        input: IdentitySignInInput;
      },
      unknown
    >,
    'mutationFn'
  >
) => useMutation(({ input: input }) => IdentityService.postIdentitySignIn(input.formData), options);
